var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:arrow-drop-down-circle-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.8587 22.6417C27.042 22.4584 27.1337 22.2445 27.1337 22C27.1337 21.7556 27.042 21.5417 26.8587 21.3584L21.7253 16.225C21.4503 15.95 21.1222 15.881 20.7408 16.0179C20.3595 16.1548 20.1682 16.4377 20.167 16.8667L20.167 27.1334C20.167 27.5612 20.3583 27.8435 20.7408 27.9804C21.1234 28.1173 21.4515 28.0488 21.7253 27.775L26.8587 22.6417ZM40.3337 22C40.3337 24.5362 39.8521 26.9195 38.889 29.15C37.9259 31.3806 36.6199 33.3209 34.9712 34.9709C33.3212 36.6209 31.3809 37.9268 29.1503 38.8887C26.9198 39.8506 24.5364 40.3322 22.0003 40.3334C19.4642 40.3334 17.0809 39.8518 14.8503 38.8887C12.6198 37.9256 10.6795 36.6197 9.02949 34.9709C7.37949 33.3209 6.07355 31.3806 5.11166 29.15C4.14977 26.9195 3.66821 24.5362 3.66699 22C3.66699 19.4639 4.14855 17.0806 5.11166 14.85C6.07477 12.6195 7.38072 10.6792 9.02949 9.02921C10.6795 7.3792 12.6198 6.07265 14.8503 5.10954C17.0809 4.14643 19.4642 3.66549 22.0003 3.66671C24.5364 3.66671 26.9198 4.14826 29.1503 5.11137C31.3809 6.07449 33.3212 7.38043 34.9712 9.02921C36.6212 10.6792 37.9277 12.6195 38.8908 14.85C39.8539 17.0806 40.3349 19.4639 40.3337 22Z",
    fill: "#062644"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextblue);
export default __webpack_public_path__ + "static/media/nextblue.858699f6f33dc65bd9f5b72b61769442.svg";
export { ForwardRef as ReactComponent };